import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=4660e03e&"
import script from "./privacy.vue?vue&type=script&lang=js&"
export * from "./privacy.vue?vue&type=script&lang=js&"
import style0 from "./privacy.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4660e03e')) {
      api.createRecord('4660e03e', component.options)
    } else {
      api.reload('4660e03e', component.options)
    }
    module.hot.accept("./privacy.vue?vue&type=template&id=4660e03e&", function () {
      api.rerender('4660e03e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/help/privacy.vue"
export default component.exports